module.exports = __webpack_public_path__ + "static/media/08Demo Photo-ink.dc5f8924.jpeg";